import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import ReportConversionContext from '@/modules/reports/contexts/ReportConversionContext';
import TableCellOrder from '@/modules/common/components/TableCellOrder';

function getText(offerName, affiliateName) {
    if (affiliateName) {
        return 'Source';
    }
    else if (offerName) {
        return 'Партнер';
    }
    else {
        return 'Оффер';
    }
}

const CellPrimary = () => {
    const reportConversionContext = useContext(ReportConversionContext);

    const { offerName, affiliateName } = useParams();

    return (
        <TableCellOrder className="primary" orderName="primary"
                        ordering={reportConversionContext.ordering}
                        onClick={reportConversionContext.handleClickOrder}
        >
            {getText(offerName, affiliateName)}
        </TableCellOrder>
    );
};

export default CellPrimary;
